// src/components/WatchlistSidebar.js
import React from "react";
import { Box, VStack, Flex, Text, IconButton, Spinner, Heading } from "@chakra-ui/react";
import { DeleteIcon, CloseIcon } from "@chakra-ui/icons";

export default function WatchlistSidebar({
  watchlist,
  priceData,
  selectedTicker,
  onSelectTicker,
  onRemoveTicker,
  onHoverTicker,
  onLeaveHover,
  loading,
  lastUpdated,
  onClose,
}) {
  return (
    <Box p={4} bg="gray.50" h="full" w={{ base: "full", md: "220px" }} overflowY="auto">
      <Flex justify="space-between" align="center" mb={2}>
        <Heading size="sm">Your Watchlist</Heading>
        <IconButton
          icon={<CloseIcon />}
          size="sm"
          aria-label="Close"
          display={{ base: "inline-flex", md: "none" }}
          onClick={onClose}
        />
      </Flex>

      {lastUpdated && <Text fontSize="xs">Last updated: {lastUpdated}</Text>}

      {loading ? (
        <Spinner />
      ) : watchlist.length === 0 ? (
        <Text fontSize="sm" color="gray.500">
          Your watchlist is empty.
        </Text>
      ) : (
        <VStack align="stretch" spacing={2} mt={2}>
          {watchlist.map((ticker) => {
            const info = priceData[ticker];
            const price = info?.price?.toFixed(2) ?? "-";
            const change = info?.changePercent?.toFixed(2) ?? "-";
            const isPositive = parseFloat(change) >= 0;
            const companyName = info?.name || "";

            return (
              <Flex
                key={ticker}
                align="center"
                justify="space-between"
                p={2}
                borderRadius="md"
                bg={selectedTicker === ticker ? "teal.50" : "transparent"}
                _hover={{ bg: "gray.100" }}
                onClick={() => onSelectTicker(ticker)}
                onMouseEnter={() => {
                  if (onHoverTicker) onHoverTicker(ticker);
                }}
                onMouseLeave={() => {
                  if (onLeaveHover) onLeaveHover();
                }}
                cursor="pointer"
              >
                {/* Column 1: Ticker + Name */}
                <Box flex="1" minW="0">
                  <Text fontWeight="bold" noOfLines={1}>
                    {ticker}
                  </Text>
                  {companyName && (
                    <Text fontSize="xs" color="gray.500" noOfLines={1}>
                      {companyName}
                    </Text>
                  )}
                </Box>

                {/* Column 2: Price + % change */}
                <Box textAlign="right" flex="1">
                  <Text fontWeight="normal">{price !== "-" ? `$${price}` : "-"}</Text>
                  <Text
                    fontSize="xs"
                    color={change === "-" ? "gray.500" : isPositive ? "green.500" : "red.500"}
                  >
                    {change === "-" ? "--" : `${isPositive ? "+" : ""}${change}%`}
                  </Text>
                </Box>

                {/* Column 3: Remove icon */}
                <Box flexShrink={0} ml={2}>
                  <IconButton
                    icon={<DeleteIcon />}
                    size="xs"
                    colorScheme="blackAlpha"
                    variant="ghost"
                    aria-label="Remove"
                    onClick={(e) => {
                      e.stopPropagation();
                      onRemoveTicker(ticker);
                    }}
                  />
                </Box>
              </Flex>
            );
          })}
        </VStack>
      )}
    </Box>
  );
}
